/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Org_Activity_View_All_CountInputs */



/**
* | output |
* | --- |
* | "View all {count}" |
*
* @param {Partner_Org_Activity_View_All_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_activity_view_all_count = /** @type {((inputs: Partner_Org_Activity_View_All_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Activity_View_All_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle ${i?.count} anzeigen`)
	return /** @type {LocalizedString} */ (`View all ${i?.count}`)
});